import { type FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Image } from '@chakra-ui/react';
import { ChallengeRequestScreenState } from '@shinetools/sca-operations';
import {
  Button,
  Typography,
  View,
  YStack,
} from '@shinetools/sunshine-universal';

import RedFlag from 'assets/brand/red-flag.png';
import SunshineModal from 'components/_core/SunshineModal';

import { modalMinHeight } from '../utils/constant';

export interface ChallengeRequestConfirmProps {
  moveState: (state: ChallengeRequestScreenState) => void;
}

const ChallengeRequestConfirm: FC<ChallengeRequestConfirmProps> = ({
  moveState,
}) => {
  return (
    <>
      <SunshineModal.Body minHeight={modalMinHeight}>
        <YStack alignItems="center" gap={24} paddingBottom="$space.24">
          <Image
            src={RedFlag}
            style={{
              marginBottom: 24,
              opacity: 1,
              width: '30%',
            }}
          />

          <Typography.Header>
            <FormattedMessage id="authentication.challenge.confirm.title" />
          </Typography.Header>
          <Typography.Text textAlign="justify">
            <FormattedMessage id="authentication.challenge.confirm.description" />
          </Typography.Text>
        </YStack>
      </SunshineModal.Body>
      <SunshineModal.Footer flexDirection="row" gap={16}>
        <View>
          <Button
            onPress={() => moveState(ChallengeRequestScreenState.Declined)}
            variant="tertiary"
          >
            <FormattedMessage id="authentication.close" />
          </Button>
        </View>

        <View marginLeft="70%">
          <Button onPress={() => moveState(ChallengeRequestScreenState.Info)}>
            <FormattedMessage id="authentication.confirm" />
          </Button>
        </View>
      </SunshineModal.Footer>
    </>
  );
};

export default ChallengeRequestConfirm;
